import React from "react";

interface InvoiceIconProps {
  color?: string;
}

const InvoiceIcon: React.FC<InvoiceIconProps> = ({ color }) => {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.68 0.666016C14.7522 0.666016 14 2.90459 14 5.66602H15.68C16.4897 5.66602 16.8945 5.66602 17.1451 5.38647C17.3957 5.10693 17.3521 4.73879 17.2648 4.00252C17.0345 2.05888 16.4119 0.666016 15.68 0.666016Z"
          stroke={color || "currentColor"}
          stroke-width="1.2"
        />
        <path
          d="M14.0013 5.71123V14.5375C14.0013 15.7972 14.0013 16.4271 13.6163 16.675C12.9872 17.0802 12.0147 16.2305 11.5256 15.9221C11.1214 15.6672 10.9194 15.5398 10.6951 15.5324C10.4527 15.5244 10.2471 15.6467 9.81036 15.9221L8.21797 16.9263C7.78842 17.1972 7.57363 17.3327 7.33463 17.3327C7.09564 17.3327 6.88085 17.1972 6.4513 16.9263L4.85891 15.9221C4.45476 15.6672 4.25268 15.5398 4.02841 15.5324C3.78607 15.5244 3.58041 15.6467 3.1437 15.9221C2.65459 16.2305 1.68203 17.0802 1.05293 16.675C0.667969 16.4271 0.667969 15.7972 0.667969 14.5375V5.71123C0.667969 3.33289 0.667969 2.14373 1.4002 1.40487C2.13243 0.666016 3.31095 0.666016 5.66797 0.666016H15.668"
          stroke={color || "currentColor"}
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 4H10.6667"
          stroke="white"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.66797 7.33203H4.0013"
          stroke={color || "currentColor"}
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.41797 8.0612C8.72761 8.0612 8.16797 8.55089 8.16797 9.15495C8.16797 9.75901 8.72761 10.2487 9.41797 10.2487C10.1083 10.2487 10.668 10.7384 10.668 11.3424C10.668 11.9465 10.1083 12.4362 9.41797 12.4362M9.41797 8.0612C9.96223 8.0612 10.4252 8.36555 10.5968 8.79036M9.41797 8.0612V7.33203M9.41797 12.4362C8.87371 12.4362 8.41069 12.1318 8.2391 11.707M9.41797 12.4362V13.1654"
          stroke={color || "currentColor"}
          stroke-width="1.2"
          stroke-linecap="round"
        />
      </svg>
    </>
  );
};
export { InvoiceIcon };

export const InvoiceSmallIcon: React.FC<InvoiceIconProps> = ({ color }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 14 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          className=""
          clipRule="evenodd"
          d="M13.2519 0.426854C13.5853 0.236381 14 0.477064 14 0.860976V17.1378C14 17.5217 13.5853 17.7624 13.2519 17.5719L10.9961 16.2829C10.6887 16.1072 10.3113 16.1072 10.0039 16.2829L7.79382 17.5458C7.30193 17.8269 6.69807 17.8269 6.20618 17.5458L3.99614 16.2829C3.68871 16.1072 3.31129 16.1072 3.00386 16.2829L0.74807 17.5719C0.414741 17.7624 0 17.5217 0 17.1378V0.860976C0 0.477064 0.414741 0.236381 0.74807 0.426854L3.00386 1.71588C3.31129 1.89155 3.68871 1.89155 3.99614 1.71588L6.20618 0.452998C6.69807 0.171917 7.30193 0.171917 7.79382 0.452999L10.0039 1.71588C10.3113 1.89155 10.6887 1.89155 10.9961 1.71588L13.2519 0.426854ZM4.5 5.99939C4.22386 5.99939 4 6.22324 4 6.49939C4 6.77553 4.22386 6.99939 4.5 6.99939H9.5C9.77614 6.99939 10 6.77553 10 6.49939C10 6.22324 9.77614 5.99939 9.5 5.99939H4.5ZM4.5 8.49939C4.22386 8.49939 4 8.72324 4 8.99939C4 9.27553 4.22386 9.49939 4.5 9.49939H9.5C9.77614 9.49939 10 9.27553 10 8.99939C10 8.72324 9.77614 8.49939 9.5 8.49939H4.5ZM4.5 10.9994C4.22386 10.9994 4 11.2232 4 11.4994C4 11.7755 4.22386 11.9994 4.5 11.9994H9.5C9.77614 11.9994 10 11.7755 10 11.4994C10 11.2232 9.77614 10.9994 9.5 10.9994H4.5Z"
          fill={color || "currentColor"}
        />
      </svg>
    </>
  );
};

export const Invoiceicon: React.FC<InvoiceIconProps> = ({ color }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 21V3L15 5L12 3L9 5L6 3V21L9 19.5L12 21L15 19.5L18 21Z"
          stroke="#044E97"
          stroke-width="2"
          stroke-linejoin="round"
        />
        <path
          d="M10 9H14"
          stroke="#044E97"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M10 15H14"
          stroke="#044E97"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M10 12H14"
          stroke="#044E97"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </>
  );
};

export const ActiveInvoiceIcon: React.FC<InvoiceIconProps> = ({ color }) => {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.33464 17.9587C7.08522 17.9587 6.87432 17.8845 6.68789 17.7926C6.52092 17.7102 6.33579 17.5934 6.14029 17.4701L6.14022 17.47L4.52552 16.4517C4.31311 16.3178 4.19152 16.2419 4.09634 16.1942C4.00823 16.1459 3.94511 16.1698 3.92456 16.1877C3.8303 16.232 3.70444 16.3083 3.4771 16.4517L3.05318 16.7429C2.87755 16.8636 2.66584 17.0031 2.44055 17.1209C2.04714 17.3268 1.3466 17.6086 0.714507 17.2015C0.286696 16.9259 0.152572 16.4719 0.0970579 16.0728C0.0429132 15.6836 0.0429396 15.175 0.0429702 14.5845V14.5844V14.5844V14.5843L0.0429768 5.66679C0.0429601 4.51621 0.0429467 3.58994 0.139981 2.86168C0.240609 2.10645 0.455689 1.47102 0.956284 0.965903C1.45765 0.460002 2.08966 0.241925 2.84078 0.140026C3.5636 0.0419656 4.48251 0.0419776 5.62183 0.0419926H5.62184H5.62185H5.62189H7.33464H15.6813L15.6834 0.0419961C16.0783 0.0426457 16.4019 0.233479 16.6419 0.467746C16.8797 0.699874 17.0719 1.00724 17.2282 1.34204C17.5418 2.01401 17.767 2.91905 17.8868 3.92995L17.8916 3.97063C17.9311 4.30344 17.9691 4.62345 17.9574 4.89387C17.9437 5.20883 17.8618 5.52581 17.6118 5.80464C17.3546 6.0916 17.0318 6.20296 16.7159 6.25018C16.4355 6.2921 16.0917 6.29205 15.7218 6.292L15.6813 6.29199H14.6263L14.6263 14.5843C14.6263 15.1749 14.6264 15.6835 14.5722 16.0728C14.5167 16.4719 14.3826 16.9259 13.9548 17.2015C13.3227 17.6086 12.6221 17.3268 12.2287 17.1209C12.0034 17.0031 11.7917 16.8636 11.6161 16.7429L11.1922 16.4517C10.9648 16.3083 10.839 16.232 10.7447 16.1877C10.7242 16.1698 10.661 16.1459 10.5729 16.1942C10.4777 16.2419 10.3562 16.3178 10.1437 16.4517L8.52904 17.47C8.33353 17.5934 8.14836 17.7102 7.98138 17.7926C7.79495 17.8845 7.58407 17.9587 7.33464 17.9587ZM15.6817 1.29506L15.6817 1.29505C15.6966 1.30217 15.7255 1.31997 15.7688 1.36225C15.8607 1.45202 15.9758 1.61435 16.0955 1.87072C16.3337 2.3811 16.535 3.14431 16.6455 4.07705C16.6916 4.46595 16.7154 4.68302 16.7086 4.83963C16.7035 4.95658 16.6832 4.96911 16.6807 4.97063C16.6778 4.97393 16.6759 4.97601 16.6654 4.98081C16.6493 4.98819 16.6111 5.00197 16.5311 5.01392C16.3543 5.04036 16.1058 5.04199 15.6813 5.04199H14.6399C14.6414 5.00626 14.6431 4.97067 14.645 4.93524C14.698 3.90528 14.8606 3.00084 15.0858 2.33053C15.0946 2.30455 15.1033 2.27905 15.1122 2.25404C15.2445 1.87885 15.3866 1.6125 15.5168 1.44868C15.5229 1.44095 15.5289 1.4336 15.5347 1.4266C15.6107 1.33547 15.6606 1.30477 15.6817 1.29506ZM4.00131 3.37533C3.65613 3.37533 3.37631 3.65515 3.37631 4.00033C3.37631 4.3455 3.65613 4.62533 4.00131 4.62533H10.668C11.0132 4.62533 11.293 4.3455 11.293 4.00033C11.293 3.65515 11.0132 3.37533 10.668 3.37533H4.00131ZM6.29297 7.33366C6.29297 7.67884 6.01315 7.95866 5.66797 7.95866H4.00131C3.65613 7.95866 3.37631 7.67884 3.37631 7.33366C3.37631 6.98848 3.65613 6.70866 4.00131 6.70866H5.66797C6.01315 6.70866 6.29297 6.98848 6.29297 7.33366ZM10.043 7.33366C10.043 6.98848 9.76315 6.70866 9.41797 6.70866C9.07279 6.70866 8.79297 6.98848 8.79297 7.33366V7.53774C8.09798 7.76446 7.54297 8.36064 7.54297 9.15658C7.54297 10.1816 8.46344 10.8753 9.41797 10.8753C9.84416 10.8753 10.043 11.161 10.043 11.3441C10.043 11.5272 9.84416 11.8128 9.41797 11.8128C9.09596 11.8128 8.88315 11.6343 8.81861 11.4746C8.68933 11.1545 8.32507 10.9999 8.00501 11.1292C7.68496 11.2584 7.53031 11.6227 7.65959 11.9427C7.85996 12.4388 8.285 12.8006 8.79297 12.9647V13.167C8.79297 13.5122 9.07279 13.792 9.41797 13.792C9.76315 13.792 10.043 13.5122 10.043 13.167V12.9629C10.738 12.7362 11.293 12.14 11.293 11.3441C11.293 10.3191 10.3725 9.62533 9.41797 9.62533C8.99179 9.62533 8.79297 9.33968 8.79297 9.15658C8.79297 8.97348 8.99179 8.68783 9.41797 8.68783C9.73998 8.68783 9.9528 8.86631 10.0173 9.02608C10.1466 9.34613 10.5109 9.50078 10.8309 9.3715C11.151 9.24222 11.3056 8.87796 11.1764 8.55791C10.976 8.06188 10.5509 7.70008 10.043 7.53593V7.33366Z"
          fill="#0D3C6D"
        />
      </svg>
    </>
  );
};
